import "core-js/modules/es.array.push.js";
import axios from 'axios';
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import config from '../config/index';
export default {
  name: 'HomeView',
  setup() {
    const romList = ref([]);
    const router = useRouter();
    // 获取游戏列表
    axios.get(`${config.serverUrl}/romStatic/romList.json`).then(res => {
      romList.value = res.data;
    });
    const goToGame = code => {
      router.push({
        name: 'playGround',
        query: {
          code
        }
      });
    };
    return {
      romList,
      goToGame,
      config
    };
  },
  components: {}
};